import { Icon } from '@opendoor/bricks';
import classNames from 'classnames';
import React from 'react';

import { formatPhoneNumberInput } from '../../helpers/formatUtils';

import './OperatorInfoBoxStyle.less';

export interface IOperatorInfoBoxProps {
  brokerage?: string;
  compact?: boolean;
  email?: string;
  fullName: string;
  operatorRole: string;
  phoneNumber?: string;
  photoUrl: string;
}

const OperatorInfoBox: React.SFC<IOperatorInfoBoxProps> = (props: IOperatorInfoBoxProps) => {
  const { brokerage, compact, email, fullName, operatorRole, phoneNumber, photoUrl } = props;

  return (
    <div className={classNames('od-operator-info-box', { compact })}>
      <div className="profile">
        {!compact && (
          <div className="profile-photo-box">
            <img className="profile-photo" src={photoUrl} />
          </div>
        )}
        <div className="basic-info-box">
          <div className="basic-info">
            <p>{fullName}</p>
            <p>{operatorRole}</p>
            {brokerage && <p>{brokerage}</p>}
          </div>
        </div>
      </div>
      <div className="more-info">
        {email && (
          <div>
            <Icon className="email-icon info-icon" name="ic-email" />
            <a href={`mailto:${email}`} target="_blank">
              {email}
            </a>
          </div>
        )}
        {phoneNumber && (
          <div>
            <Icon className="phone-icon info-icon" name="ic-phone" />
            <a href={`tel:${phoneNumber}`} target="_blank">
              {formatPhoneNumberInput(phoneNumber)}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default OperatorInfoBox;
